import React from 'react';
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {DatePicker} from "@mui/x-date-pickers";
import {TextField} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider/LocalizationProvider";
import {convertDate} from "./helper";

type Props = {
    field: string,
    setFieldValue: (field: string, val: any) => void,
    handleSubmit: () => void,

}

const CustomDatePicker: React.FC<Props> = ({field, setFieldValue, handleSubmit}) => {
    const [date, setDate] = React.useState<Date | null>(null);

    const onChange = (value: any) => {
        setDate(value)
        // setFieldValue(field, value?.toLocaleDateString().split('.').reverse().join('-'))
        if (value){
            setFieldValue(field, convertDate(value))
        } else {
            setFieldValue(field, '')
        }

        handleSubmit()
    }

    return (
        <>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                {<DatePicker
                    value={date}
                    onChange={(newValue: any, s) => {
                        onChange(newValue);
                    }}
                    renderInput={(params: any) => <TextField {...params}
                                                             sx={{
                                                                 color: "primary.dark",
                                                                 input: {
                                                                     color: "primary.dark",
                                                                     fontWeight: "600"
                                                                 },
                                                                 width: "180px"
                                                             }}
                        // error={formik.touched.date && Boolean(formik.errors.date)}
                        // helperText={formik.touched.date && formik.errors.date}
                        // disabled={isDisabled}
                    />}
                />}
            </LocalizationProvider>

        </>
    );
};

export default CustomDatePicker;